export const drawerWidthExpanded = 210;
export const drawerWidthExpandedMobile = 250;
export const drawerWidth = 80;
export const drawerNestedMenuWidth = 300;
export const navigationBarHeight = 64;
export const appLoaderHeight = 4;
